import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

interface Banner {
  title: string;
  image: string;
  url: string;
}

const BANNERS: Banner[] = [
  /* {
    title: 'Tratado de los Recursos',
    image: 'home-banner-1.png',
    url: '/book/0093400_2ED',
  }, */
  /* {
    title: 'Derecho y Regulación de la Inteligencia Artificial',
    image: 'home-banner-2.png',
    url: '/book/00112500',
  }, */
  {
    title: 'Conocé Astrea Virtual',
    image: 'home-banner-3.png',
    url: '/astreavirtual',
  },
  {
    title: 'Ver catálogo',
    image: 'home-banner-4.png',
    url: '/store',
  },
];

@Component({
  selector: 'astrea-banner-welcome',
  templateUrl: './banner-welcome.component.html',
  styleUrls: ['./banner-welcome.component.scss']
})
export class BannerWelcomeComponent implements OnInit, OnDestroy {
  public banners: Banner[] = BANNERS;
  public currentBannerIndex = 0;
  public intervalId: any;
  public isFading = false;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  ngOnInit() {
    if (this.isBrowser) {
      this.startBannerRotation();
    }
  }

  ngOnDestroy() {
    if (this.isBrowser) {
      this.stopBannerRotation();
    }
  }

  startBannerRotation() {
    this.stopBannerRotation();
    this.intervalId = setInterval(() => {
      this.nextBanner();
    }, 3000);
  }

  stopBannerRotation() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  nextBanner() {
    this.animateChange(() => {
      this.currentBannerIndex = (this.currentBannerIndex + 1) % this.banners.length;
    });
  }

  previousBanner() {
    this.animateChange(() => {
      this.currentBannerIndex =
        (this.currentBannerIndex - 1 + this.banners.length) % this.banners.length;
    });
  }

  animateChange(action: () => void) {
    this.isFading = true;
    if (this.isBrowser) {
      setTimeout(() => {
        action();
        this.isFading = false;
      }, 200);
    } else {
      action();
      this.isFading = false;
    }
  }

  get currentBanner(): Banner {
    return this.banners[this.currentBannerIndex];
  }

  get currentImageSrc(): string {
    return `/assets/images/banners/${this.currentBanner.image}`;
  }

  get isBrowser() {
    return isPlatformBrowser(this.platformId);
  }
}
